import axios from 'axios';
import {
  SSO_PROVIDER_PBB,
  SSO_PROVIDER_TYLER,
} from '../static/keyWords.js';

const SILENT_AUTH_ATTEMPT_KEY = 'silentAuthAttempted';
const SILENT_AUTH_ENVIRONMENTS = new Set(['local', 'dev', 'production', 'prod']);

const getLoginConfiguration = async () => {
  const response = await axios.get('/api/auth/config', {
    withCredentials: true,
  });

  return response.data;
};

const login = async (email, ssoProvider = SSO_PROVIDER_TYLER) => {
  const response = await axios.post(
    '/api/auth',
    { email, ssoProvider },
    { withCredentials: true },
  );

  window.location.href = response.data.redirectUrl;
};

const canAttemptSilentAuthentication = () => (
  SILENT_AUTH_ENVIRONMENTS.has(process.env.ENVIRONMENT) &&
  sessionStorage.getItem(SILENT_AUTH_ATTEMPT_KEY) !== 'true'
);

const startSilentAuthentication = (
  returnTo,
  ssoProvider = process.env.ENVIRONMENT === 'production'
    ? SSO_PROVIDER_TYLER
    : SSO_PROVIDER_PBB
) => {
  sessionStorage.setItem(SILENT_AUTH_ATTEMPT_KEY, 'true');
  const query = new URLSearchParams({
    ssoProvider,
    returnTo,
  });

  window.location.assign(`/api/auth/silent?${query.toString()}`);
};

const clearSilentAuthenticationAttempt = () => {
  sessionStorage.removeItem(SILENT_AUTH_ATTEMPT_KEY);
};

export {
  canAttemptSilentAuthentication,
  clearSilentAuthenticationAttempt,
  getLoginConfiguration,
  login,
  startSilentAuthentication,
};
